import type {State} from 'src/reducers';

import type {Filters, ScheduledEvents} from 'src/types/scheduler/events';


export const selectPastEventsAPIParams = (state: State): Filters => {
  return state.scheduler.events.past.filters;
};

export const selectPastEvents = (state: State): ScheduledEvents => {
  // @ts-expect-error - TS2339 - Property 'past' does not exist on type 'SchedulerState'.
  return state.scheduler.events.past;
};

export const selectUpcomingEventsAPIParams = (state: State): Filters => {
  return state.scheduler.events.upcoming.filters;
};

export const selectUpcomingEvents = (state: State): ScheduledEvents => {
  // @ts-expect-error - TS2339 - Property 'upcoming' does not exist on type 'SchedulerState'.
  return state.scheduler.events.upcoming;
};
